<div style="position: absolute; top: 0; left: 0; right: 0; bottom: 0">
	@if (raceStreamDisabled()) {
		<div class="video-error h-full justify-center">
			<div class="video-error-icon">
				<svg fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
					<circle cx="12" cy="12" r="10" />
					<line x1="12" y1="8" x2="12" y2="12" />
					<line x1="12" y1="16" x2="12.01" y2="16" />
				</svg>
			</div>
			<p class="video-error-text">Race stream has been disabled by admin.</p>
		</div>
	} @else if (streamData && streamData.id !== 'twitch-stream') {
		<vbrick-player [config]="streamPlayerConfig.playerConfig"
			[playbackOptions]="streamPlayerConfig.sources"
			[isLive]="streamPlayerConfig.isLive"
			[autoPlay]="streamPlayerConfig.autoPlay"
			[translations]="PLAYER_TRANSLATIONS"
			[disableUserPreferenceStore]="true"
			[playbackUnavailableMsgTemplate]="playbackUnavailableTemplate"
			(onComplete)="onPlaybackEnded()"
			(onPlayerReady)="onPlayerReady($event.vgAPI)">
		</vbrick-player>
	} @else if (streamData && streamData.id === 'twitch-stream') {
		<div id="twitch-player-container" class="w-full h-full">
			@if (!twitchPlayerLoaded) {
				<div class="race-not-happening-place-holder d-flex align-items-center justify-content-center">
					<div class="text-center m-0" style="color: white" role="alert">
						Twitch Player is loading...
					</div>
				</div>
			}
		</div>
	}
</div>

<ng-template #playbackUnavailableTemplate>
	<div class="video-error">
		<div class="video-error-icon">
			<svg fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
				<circle cx="12" cy="12" r="10" />
				<line x1="12" y1="8" x2="12" y2="12" />
				<line x1="12" y1="16" x2="12.01" y2="16" />
			</svg>
		</div>
		<p class="video-error-text">Stream temporarily unavailable. Please try again.</p>
	</div>
</ng-template>
